import { render, staticRenderFns } from "./delete-children-warning.vue?vue&type=template&id=75d6cc1a&scoped=true"
import script from "./delete-children-warning.vue?vue&type=script&lang=js"
export * from "./delete-children-warning.vue?vue&type=script&lang=js"
import style0 from "./delete-children-warning.vue?vue&type=style&index=0&id=75d6cc1a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75d6cc1a",
  null
  
)

export default component.exports